<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="tab">
        <div
          class="tab-item"
          :class="currTap === 0 ? 'active' : ''"
          @click="onTap(0)"
        >
          <I18Lang id="text98" defaultText="每日成长赠金" />
        </div>
        <div
          class="tab-item"
          :class="currTap === 1 ? 'active' : ''"
          @click="onTap(1)"
        >
          <I18Lang id="text102" defaultText="激活记录" />
        </div>
      </div>

      <div v-if="currTap === 0">
        <div class="header-panel">
          <div class="statistics">
            <div class="statistic-item">
              <div class="label">
                <I18Lang id="text103" defaultText="累计每日成长赠金（MEQ-P）" />
              </div>
              <div class="num">{{ giftInfo.total_opx_s }}</div>
            </div>
            <div class="statistic-item">
              <div class="label">
                <I18Lang id="text82" defaultText="剩余每日成长赠金（MEQ-P）" />
              </div>
              <div class="num">{{ giftInfo.opx_s }}</div>
            </div>
            <div class="statistic-item">
              <div class="label">
                <I18Lang id="text104" defaultText="累计获得元股（MEQ）" />
              </div>
              <div class="num">{{ giftInfo.total_opx }}</div>
            </div>
          </div>
          <div class="btn-rule" @click="dialogVisible = true"></div>
        </div>

        <div class="reset-table table">
          <el-table :data="tableDataMining.list" style="width: 100%">
            <el-table-column width="200" label="流水号" prop="id">
              <template slot="header">
                <I18Lang id="text14" defaultText="流水号" />
              </template>
            </el-table-column>
            <el-table-column label="日期" prop="settle_date">
              <template slot="header">
                <I18Lang id="text105" defaultText="日期" />
              </template>
            </el-table-column>

            <el-table-column label="存储空间价值" prop="fixed_value">
              <template slot="header">
                <I18Lang id="text78" defaultText="存储空间价值" />
              </template>
            </el-table-column>

            <el-table-column label="奖励比例" prop="settle_rate">
              <template slot="header">
                <I18Lang id="text74" defaultText="奖励比例" />
              </template>
              <template slot-scope="scope">
                {{ formatSettleRate(scope.row.settle_rate) }}
              </template>
            </el-table-column>

            <el-table-column label="每日成长赠金金额（MEQ-P）" prop="opx_s">
              <template slot="header">
                <I18Lang id="text79" defaultText="每日成长赠金金额（MEQ-P）" />
              </template>
            </el-table-column>

            <el-table-column label="奖励元股（MEQ）" prop="opx">
              <template slot="header">
                <I18Lang id="text80" defaultText="奖励元股（MEQ）" />
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              background
              @current-change="pageChangeMining"
              layout="prev, pager, next"
              :total="tableDataMining.total"
            ></el-pagination>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="header-panel">
          <div class="statistics">
            <div class="statistic-item">
              <div class="label"><I18Lang id="text106" defaultText="已激活风险补偿赠金（MEQ-A）" /></div>
              <div class="num">{{ giftInfo.opx_t }}</div>
            </div>
          </div>
          <div class="btn-rule" @click="dialogVisible = true"></div>
        </div>

        <div class="reset-table table">
          <el-table :data="tableDataActivation.list" style="width: 100%">
            <el-table-column width="200" label="流水号" prop="id">
              <template slot="header">
                <I18Lang id="text25" defaultText="流水号" />
              </template>
            </el-table-column>
            <el-table-column label="日期" prop="settle_date">
              <template slot="header">
                <I18Lang id="text105" defaultText="日期" />
              </template>
            </el-table-column>

            <el-table-column label="入金金额（MEQ）" prop="recharge_amount">
              <template slot="header">
                <I18Lang id="text72" defaultText="入金金额（MEQ）" />
              </template>
            </el-table-column>

            <el-table-column label="注入流动性净值" prop="net_amount">
              <template slot="header">
                <I18Lang id="text73" defaultText="净值" />
              </template>
            </el-table-column>

            <el-table-column label="奖励比例" prop="settle_rate">
              <template slot="header">
                <I18Lang id="text74" defaultText="奖励比例" />
              </template>
              <template slot-scope="scope">
                {{ formatSettleRate(scope.row.settle_rate) }}
              </template>
            </el-table-column>

            <el-table-column label="天数" prop="day">
              <template slot="header">
                <I18Lang id="text75" defaultText="天数" />
              </template>
            </el-table-column>

            <el-table-column width="180" label="激活金额（MEQ-A）" prop="opx_t">
              <template slot="header">
                <I18Lang id="text86" defaultText="激活金额（MEQ-A）" />
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              background
              @current-change="pageChangeActivation"
              layout="prev, pager, next"
              :total="tableDataActivation.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="info-dialog"
    >
      <template slot="title">
        <I18Lang
          id="text329"
          defaultText="每日成长赠金规则（MEQ-P）"
          style="color:#fff;font-size: 18px;"
        />
      </template>
      <div class="dialog-content">
        <div class="title">
          <I18Lang id="text330" defaultText="一、定义" />
        </div>
        <p>
          <I18Lang
            id="text233"
            defaultText="每日成长赠金（Pending Meta Equity，简称“MEQ-P”）系平台基于既定规则向用户发放的待激活权益额度，不构成用户实际资产或可支配资金。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text331" defaultText="二、发放规则" />
        </div>
        <p>
          <I18Lang
            id="text234"
            defaultText="1.用户完成平台注册后，即视为参与本活动。"
          />
        </p>
        <p>
          <I18Lang
            id="text235"
            defaultText="2.平台根据设定的奖励基础和奖励比例，按日计算并给用户发放MEQ-P。"
          />
        </p>
        <p>
          <I18Lang
            id="text236"
            defaultText="3.MEQ-P按自然日发放，具体发放时间及比例以平台系统记录为准。"
          />
        </p>
        <p>
          <I18Lang
            id="text237"
            defaultText="4.MEQ-P可在未激活状态下持续累计。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text332" defaultText="三、权益属性" />
        </div>
        <p>
          <I18Lang
            id="text239"
            defaultText="MEQ-P仅为未激活权益，不具备资金属性，且明确具有以下限制："
          />
        </p>
        <p>
          <I18Lang
            id="text240"
            defaultText="1.不得用于任何形式的交易；"
          />
        </p>
        <p>
          <I18Lang
            id="text241"
            defaultText="2.不得用于抵扣交易亏损；"
          />
        </p>
        <p>
          <I18Lang
            id="text242"
            defaultText="3.不得提现、转让、赠与或变现；"
          />
        </p>
        <p>
          <I18Lang
            id="text243"
            defaultText="4.不产生利息、收益或其他形式的回报；"
          />
        </p>
        <p>
          <I18Lang
            id="text244"
            defaultText="5.不构成存款、资产或任何形式的收益承诺。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text333" defaultText="四、激活机制" />
        </div>
        <p>
          <I18Lang
            id="text245"
            defaultText="1.当用户满足平台设定的激活条件（包括但不限于完成入金等行为）后，MEQ-P将自动转化为风险补偿赠金（MEQ-A），激活公式为："
          />
        </p>
        <p class="formula">
          <I18Lang
            id="text246"
            defaultText="可激活MEQ-P =（本次入金 - 上次激活后的总出金）× 奖励比例 × 持续天数"
          />
        </p>
        <p>
          <I18Lang
            id="text247"
            defaultText="2.转化比例、条件及具体规则以平台实时公布为准。"
          />
        </p>
        <p>
          <I18Lang
            id="text248"
            defaultText="3.转化完成后，原MEQ-P不再保留。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text334" defaultText="五、失效与处理" />
        </div>
        <p>
          <I18Lang
            id="text249"
            defaultText="1.如用户账户存在异常、违规操作或违反平台规则行为，平台有权取消或清除其MEQ-P权益。"
          />
        </p>
        <p>
          <I18Lang
            id="text250"
            defaultText="2.如用户长期未满足激活条件，平台有权根据运营规则对MEQ-P进行调整或失效处理。"
          />
        </p>

        <div class="title t2">
          <I18Lang id="text335" defaultText="六、规则变更" />
        </div>
        <p>
          <I18Lang
            id="text251"
            defaultText="平台有权根据业务发展需要，对MEQ-P的发放标准、计算方式及激活规则进行调整，并通过公告形式提前通知。"
          />
        </p>

        <div class="btn kg-btn2" @click="dialogVisible = false">
          <I18Lang id="my98" defaultText="Close" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fileDomain } from '@utils'
import { mapState } from 'vuex'
import i18n from '@utils/i18n'
export default {
  name: 'record',
  data () {
    return {
      fileDomain,
      dialogVisible: false,
      currTap: 0,
      queryFormMining: {
        page: '',
        size: ''
      },
      statusOptions: {
        0: i18n.t('text41'),
        1: i18n.t('text42')
      },
      queryFormActivation: {
        page: '',
        size: ''
      },
      tableDataMining: {
        list: [],
        total: 0
      },
      tableDataActivation: {
        list: [],
        total: 0
      },
      statusList: {
        1: i18n.t('text43'),
        2: i18n.t('text44')
      },
      giftInfo: {}
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created () {
    this.getGiftInfo()
    this.getRecordMining()
    this.getRecordActivation()
  },
  methods: {
    formatSettleRate (value) {
      if (value === null || value === undefined || value === '') {
        return '--'
      }

      // 数据库存储的是小数计算系数，例如 0.01；页面按百分比显示为 1.00%。
      // 同时兼容接口返回 "0.01%" 的历史格式。
      const numericValue = Number(String(value).trim().replace(/%+$/, ''))
      if (!Number.isFinite(numericValue)) {
        return '--'
      }
      return `${(numericValue * 100).toFixed(2)}%`
    },
    getGiftInfo () {
      this.$http.post('/api/activity/opxInfo').then((result) => {
        this.giftInfo = result
      })
    },
    onTap (type) {
      this.currTap = type
      if (type === 0) {
        this.getRecordMining()
      } else {
        this.getRecordActivation()
      }
    },
    pageChangeMining (page) {
      this.queryFormMining.page = page
      this.getRecordMining()
    },
    getRecordMining () {
      this.$http
        .post('/api/activity/opxSRecords', this.queryFormMining)
        .then((result) => {
          this.tableDataMining = result
        })
    },
    pageChangeActivation (page) {
      this.queryFormActivation.page = page
      this.getRecordActivation()
    },
    getRecordActivation () {
      this.$http
        .post('/api/activity/opxTRecords', this.queryFormActivation)
        .then((result) => {
          this.tableDataActivation = result
        })
    }
  }
}
</script>
<style scoped lang="scss">
.app-page {
  .tab {
    display: flex;
    margin-top: 17px;

    .tab-item {
      width: 186px;
      height: 42px;
      line-height: 42px;
      background: url("../../../assets/img/bonus/tab.png") no-repeat center /
        100% 100%;
      color: #fff;
      font-size: 16px;
      text-align: center;
      cursor: pointer;

      &:first-child {
        margin-right: 19px;
      }

      &.active {
        background: url("../../../assets/img/bonus/tab-active.png") no-repeat
          center / 100% 100%;
      }
    }
  }

  .header-panel {
    display: flex;
    align-items: center;

    .statistics {
      display: flex;
      margin: 20px 0;

      .statistic-item {
        width: 330px;
        height: 69px;
        background: url("../../../assets/img/bonus/statistics-item-bg.png")
          no-repeat center / 100% 100%;
        margin-right: 20px;

        .label {
          text-align: center;
          color: #fff;
          font-size: 16px;
          line-height: 16px;
          margin-top: 10px;
        }

        .num {
          text-align: center;
          font-size: 26px;
          line-height: 26px;
          margin-top: 10px;
          color: #00cbfa;
        }
      }
    }

    .receive-gift {
      .btn {
        width: 120px;
        height: 55px;
        line-height: 58px;
        overflow: hidden;
      }

      .auto-receive-gift {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #fff;

        .text {
          margin-left: 4px;
        }
      }
    }

    .btn-rule {
      color: #fff;
      margin-top: -18px;
      height: 46px;
      line-height: 46px;
      font-size: 14px;
      min-width: 45px;
      text-shadow: 2px 2px 10px #00cffb;
      text-align: center;
      background: url("../../../assets/img/btn/bt3down.png") no-repeat center /
        100% 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &::before {
        content: "";
        width: 22px;
        height: 22px;
        display: block;
        background: url("../../../assets/img/bonus/btn-rule.png") no-repeat
          center / 100% 100%;
      }

      &:hover {
        background: url("../../../assets/img/btn/bt3hov.png") no-repeat center /
          100% 100%;
      }

      &.btn-query-refresh {
        height: 42px;
      }
    }
  }
}

::v-deep .info-dialog {
  .el-dialog {
    width: min(720px, calc(100vw - 32px)) !important;
    margin-top: 8vh !important;
    border-radius: 18px;
    overflow: hidden;
    background: url("../../../assets/img/dialog-bg/bg2.png") no-repeat center /
      100% 100%;
    box-shadow: 0 20px 48px rgba(0, 17, 42, 0.45);
  }

  .el-dialog__header {
    padding: 24px 28px 0;
  }

  .el-dialog__title {
    display: block;
    padding-right: 24px;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
    color: #fff;
    text-shadow: 0 4px 16px rgba(0, 207, 251, 0.35);
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 20px;

    .el-dialog__close {
      color: rgba(255, 255, 255, 0.78);
      transition: color 0.2s ease;

      &:hover {
        color: #fff;
      }
    }
  }

  .el-dialog__body {
    padding: 40px 28px 28px;
    max-height: calc(100vh - 180px);
    overflow-y: auto;
  }
}

.dialog-content {
  color: #fff;

  .title {
    font-size: 17px;
    font-weight: 600;
    line-height: 1.5;
    color: #01c8ff;

    &:first-child {
      margin-top: 4px;
    }

    &.t2 {
      margin-top: 10px;
    }
  }

  p {
    margin: 10px 0 0;
    font-size: 14px;
    line-height: 26px;
    color: rgba(255, 255, 255, 0.92);
    word-break: break-word;
  }

  .formula {
    margin-top: 12px;
    padding: 10px 14px;
    border-left: 3px solid #01c8ff;
    border-radius: 10px;
    background: rgba(1, 178, 245, 0.08);
    color: #d7f7ff;
  }

  .btn {
    width: 168px;
    margin: 24px auto 0;
    display: block;
    text-align: center;
    line-height: 46px;
  }
}

@media (max-width: 768px) {
  ::v-deep .info-dialog {
    .el-dialog {
      margin-top: 4vh !important;
    }

    .el-dialog__header {
      padding: 20px 20px 0;
    }

    .el-dialog__title {
      font-size: 18px;
    }

    .el-dialog__body {
      padding: 22px 20px 24px;
      max-height: calc(100vh - 120px);
    }
  }

  .dialog-content {
    .title {
      font-size: 16px;
    }

    p {
      line-height: 24px;
    }

    .btn {
      width: 150px;
    }
  }
}
</style>
